import { OPTION_RECOMMENDATIONS, OPTION_RECOMMENDATIONS_ERROR, OPTION_RECOMMENDATIONS_HIDE_ERROR, OPTION_RECOMMENDATIONS_STOP_LOADER, } from "../interface/iOpRecommendation";
import { OPTION_CHAIN_START_LOADER } from "../interface/iOptionChain";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const optionRecommendations = (state = initState, action) => {
    switch (action.type) {
        case OPTION_RECOMMENDATIONS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case OPTION_RECOMMENDATIONS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case OPTION_RECOMMENDATIONS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case OPTION_CHAIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case OPTION_RECOMMENDATIONS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default optionRecommendations;
